import { Box, Stack, ToggleButton, Tooltip } from '@mui/material';
import { ReceiveToggleButtonGroupConfig } from 'src/types/shared';


interface ReceiveToggleButtonGroupProps<T> {
  config: ReceiveToggleButtonGroupConfig<T>[];
  value: T;
  disabled?: boolean;
  groupTooltip?: string;
  onChange: (value: T) => void;
  direction?: 'row' | 'column';
}

export const ReceiveToggleButtonGroup = <T extends string | number>({
  config,
  value,
  disabled: groupDisabled,
  groupTooltip,
  onChange,
  direction,
}: ReceiveToggleButtonGroupProps<T>) => {
  return (
    <Stack spacing={2} sx={{ flexDirection: direction || { xs: config.length < 3 ? 'row' : 'column', md: 'row' } }}>
      {config.map(({ value: configItemValue, label, Icon, disabled, tooltip }) => {
        const isDisabled = groupDisabled || disabled;
        const disabledTooltip = groupTooltip || tooltip;

        const toggleButton = (
          <ToggleButton
            key={configItemValue as string}
            value={configItemValue as NonNullable<T>}
            selected={configItemValue === value}
            onChange={(_, newValue: T) => {
              onChange(newValue);
            }}
            disabled={isDisabled}
            color="primary"
            size="large"
            sx={{
              width: '100%',
            }}
          >
            <Icon sx={{ mr: 1 }} /> {label}
          </ToggleButton>
        );

        return disabledTooltip && isDisabled ? (
          <Tooltip arrow title={disabledTooltip} key={configItemValue as string}>
            <Box component="span" display="flex" flex={1}>
              {toggleButton}
            </Box>
          </Tooltip>
        ) : (
          <Box component="span" display="flex" flex={1} key={configItemValue as string}>
            {toggleButton}
          </Box>
        );
      })}
    </Stack>
  );
};
